var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemobilisationStarted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.33333L4.83333 6.5M4.83333 6.5L7 8.66667M4.83333 6.5H9.16667M4.725 11.375H9.275C10.1851 11.375 10.6401 11.375 10.9877 11.1979C11.2935 11.0421 11.5421 10.7935 11.6979 10.4877C11.875 10.1401 11.875 9.68509 11.875 8.775V4.225C11.875 3.31491 11.875 2.85987 11.6979 2.51227C11.5421 2.2065 11.2935 1.95791 10.9877 1.80211C10.6401 1.625 10.1851 1.625 9.275 1.625H4.725C3.81491 1.625 3.35987 1.625 3.01227 1.80211C2.7065 1.95791 2.45791 2.2065 2.30211 2.51227C2.125 2.85987 2.125 3.31491 2.125 4.225V8.775C2.125 9.68509 2.125 10.1401 2.30211 10.4877C2.45791 10.7935 2.7065 11.0421 3.01227 11.1979C3.35987 11.375 3.81491 11.375 4.725 11.375Z",
    stroke: "#6AAFDC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemobilisationStarted);
export default __webpack_public_path__ + "static/media/DemobilisationStarted.f7ba332005a9c152c7f96a78d4139b69.svg";
export { ForwardRef as ReactComponent };